import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/mic.tsx
var Mic = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M12 19V21M12 19C8.31423 19 6.13481 16.7451 5 15M12 19C15.6858 19 17.8652 16.7451 19 15M16.0082 7V11C16.0082 13.2091 14.2137 15 12 15C9.78633 15 7.99179 13.2091 7.99179 11V7C7.99179 4.79086 9.78633 3 12 3C14.2137 3 16.0082 4.79086 16.0082 7Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.24125 7C7.24125 4.37665 9.37182 2.25 12 2.25C14.6282 2.25 16.7587 4.37665 16.7587 7V11C16.7587 13.6234 14.6282 15.75 12 15.75C9.37182 15.75 7.24125 13.6234 7.24125 11V7ZM4.59244 14.3709C4.94054 14.1454 5.40586 14.2443 5.63176 14.5917C6.69655 16.2295 8.67425 18.25 12 18.25C15.3257 18.25 17.3035 16.2295 18.3682 14.5917C18.5941 14.2443 19.0595 14.1454 19.4076 14.3709C19.7557 14.5963 19.8547 15.0608 19.6288 15.4083C18.5011 17.1429 16.3422 19.436 12.7514 19.7206V21C12.7514 21.4142 12.415 21.75 12 21.75C11.585 21.75 11.2486 21.4142 11.2486 21V19.7206C7.65783 19.436 5.49895 17.1429 4.37118 15.4083C4.14528 15.0608 4.24434 14.5963 4.59244 14.3709Z",
		fill: "currentColor"
	})
});
//#endregion
export { Mic };
